export const LIST_NOTIFICATIONS = '[Notifications] List notifications';
export const LIST_NOTIFICATIONS_SUCCESS =
  '[Notifications] List notifications Success';
export const LIST_NOTIFICATIONS_ERROR =
  '[Notifications] List notifications Error';

export const ALL_NOTIFICATIONS_LOADED = '[Notifications] Notifications Loaded';

export const MARK_AS_READ = '[Notifications] mark as read';
export const MARK_AS_READ_SUCCESS = '[Notifications] mark as read Success';
export const MARK_AS_READ_ERROR = '[Notifications] mark as read Error';

export const CLEAR_NOTIFICATIONS = '[Notifications] clear notifications';
export const CLEAR_NOTIFICATIONS_SUCCESS =
  '[Notifications] clear notifications Success';
export const CLEAR_NOTIFICATIONS_ERROR =
  '[Notifications] clear notifications Error';

export const SET_ACTIVE_SYNC_NOTIFICATION =
  '[Notifications] set active sync notification';
export const UPDATE_NOTIFICATION_INVITE_STATUS =
  '[Notifiactions] update invite status';
